// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"480":"6767b9f6","532":"94fdb77e","905":"ecab1d69","988":"abe78d5a"}[chunkId] + ".chunk.css";
};